export const ACTIVITY_REASON = {
	AssignedToIssue: 1,
	IssueCommented: 2,
	IssueCreated: 3,
	IssueUpdated: 4,
	FileAdded: 5,
	ProjectUserAdded: 6,
	Other: 9,
} as const;

export type ActivityReason =
	(typeof ACTIVITY_REASON)[keyof typeof ACTIVITY_REASON];
